// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2C_9v","title":"Images90_title__3beYH","images":"Images90_images__23mSL"};